import { z } from 'zod';
import { passwordFieldSchema } from './fields';

export const postNewPasswordSchema = (t) =>
  z.object({
    oldPassword: passwordFieldSchema(t),
    newPassword: passwordFieldSchema(t),
  });
